import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function campanhaReducer(state = initialState.campanha, action){
    switch(action.type) {
        case types.GRAVAR_CAMPANHA:
            
            return action.campanha;
            case types.OBTER_CAMPANHA_POR_TOKEN:
            
            return action.campanha;
            case types.OBTER_CAMPANHA_POR_IDCAMPANHA:
            
            return action.campanha;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/campanhaReducer.js
 **/